/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FraudControlConfig } from './FraudControlConfig';
import {
    FraudControlConfigFromJSON,
    FraudControlConfigFromJSONTyped,
    FraudControlConfigToJSON,
} from './FraudControlConfig';

/**
 * 
 * @export
 * @interface FraudControlConfigResponse
 */
export interface FraudControlConfigResponse {
    /**
     * `null` when fraud controls have not been configured for the customer.
     * @type {FraudControlConfig}
     * @memberof FraudControlConfigResponse
     */
    config?: FraudControlConfig | null;
}

/**
 * Check if a given object implements the FraudControlConfigResponse interface.
 */
export function instanceOfFraudControlConfigResponse(value: object): value is FraudControlConfigResponse {
    return true;
}

export function FraudControlConfigResponseFromJSON(json: any): FraudControlConfigResponse {
    return FraudControlConfigResponseFromJSONTyped(json, false);
}

export function FraudControlConfigResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FraudControlConfigResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'config': json['config'] == null ? undefined : FraudControlConfigFromJSON(json['config']),
    };
}

export function FraudControlConfigResponseToJSON(value?: FraudControlConfigResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'config': FraudControlConfigToJSON(value['config']),
    };
}

